import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from 'hooks/useAuth';
import { useUser } from 'state/auth';

const ForceLogoutRoute = () => {
  const { user } = useUser();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (user) {
      // Store the current path before logout
      const currentPath = location.pathname;

      logout();
      // After logout, redirect back to the original path
      navigate(currentPath, { replace: true });
    }
  }, [user, logout, navigate, location]);

  return <Outlet />;
};

export default ForceLogoutRoute;
